import { fromJS } from 'immutable';
import {
    PRACTITIONERS_GET_FAILED,
    PRACTITIONERS_GET,
    PRACTITIONERS_GET_SUCCESS
} from '../actions/practitioners';

const initialState = fromJS({
    isFetching: false,
    isFailed: false,
    data: []
});

const practitioners = (state = initialState, action) => {
    switch(action.type) {
        case PRACTITIONERS_GET:
            return state.merge(
                {
                    isFetching: true
                }
            );

        case PRACTITIONERS_GET_SUCCESS:
            return state.merge(
                {
                    isFetching: false,
                    data: action.branches
                }
            );

        case PRACTITIONERS_GET_FAILED:
            return state.merge(
                {
                    isFetching: false,
                    isFailed: true
                }
            );

        default:
            return state;
    }
};

export default practitioners;


/** WEBPACK FOOTER **
 ** ./src/reducers/practitioners.js
 **/